import {
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import {
  draftSenderId,
  draftWithSender,
  type SenderDraft,
  type SenderKind,
} from "../../logic/invoice-sender";
import { InvoiceSenderPicker } from "./InvoiceSenderPicker";

export type InvoiceSenderFieldProps = {
  value: SenderDraft;
  onChange: (next: SenderDraft) => void;
};

/**
 * The invoice form's "From": a Payee | Source toggle above one picker. An
 * invoice names exactly one sender, so the toggle decides which registry the
 * picker draws from; each kind keeps its own pick while the other is shown.
 */
export const InvoiceSenderField = ({
  value,
  onChange,
}: InvoiceSenderFieldProps) => (
  <Stack spacing={1}>
    <Stack
      direction="row"
      spacing={1}
      sx={{ alignItems: "center", justifyContent: "space-between" }}
    >
      <Typography variant="caption" color="text.secondary">
        From
      </Typography>
      <ToggleButtonGroup
        size="small"
        exclusive
        value={value.kind}
        aria-label="Invoice sender kind"
        onChange={(_, next: SenderKind | null) => {
          // Exclusive groups report null when the active button is clicked
          // again; there is always a kind, so keep the current one.
          if (next) onChange({ ...value, kind: next });
        }}
      >
        <ToggleButton value="payee">Payee</ToggleButton>
        <ToggleButton value="source">Source</ToggleButton>
      </ToggleButtonGroup>
    </Stack>
    <InvoiceSenderPicker
      required
      kind={value.kind}
      value={draftSenderId(value)}
      onChange={(ref) =>
        onChange(
          ref
            ? draftWithSender(value, ref)
            : value.kind === "payee"
              ? { ...value, payeeId: null }
              : { ...value, sourceId: null },
        )
      }
    />
  </Stack>
);
